import { useConfirmEmailChangeMutation } from 'shared/hooks/queries/use-confirm-email-change-mutation';

export const useConfirmEmailChange = () => {
  const { mutate, isPending, isSuccess, data, error } =
    useConfirmEmailChangeMutation();

  return {
    confirmEmailChange: mutate,
    isLoading: isPending,
    isSuccess,
    email: data,
    error: error?.kind,
  };
};
